import { makeVar } from '@apollo/client';
import { IDirectoryNodes } from './graphql/useMainDirectoryQuery';

export const entryDirectorySorting = makeVar<global.GridSortingVars>({ field: '', order: 'ASC' });
export const entryDirectoryCurrentPage = makeVar<number>(1);
export const entryDirectoryPageAmount = makeVar<number>(Number(localStorage.getItem('entryDirectoryPageAmount')) || 50);
export const entryDirectorySearchFor = makeVar<string>('');

type PhotoPopup = {
    visible: boolean;
    data?: IDirectoryNodes
};

export const avatarImagePopup = makeVar<PhotoPopup>({ visible: false });
